import { toast as sonnerToast } from 'sonner';

// Keep track of active toasts to prevent duplicates
const activeToasts = new Set();

// Helper to create a unique key for toast deduplication
const createToastKey = (message, type) => {
  return `${type}:${message}`;
};

// Custom toast wrapper with deduplication
const showToast = (message, type, options = {}) => {
  const key = createToastKey(message, type);
  
  // Prevent duplicate toasts
  if (activeToasts.has(key)) {
    return;
  }
  
  activeToasts.add(key);
  
  // Remove from active set after duration
  const duration = options.duration || 3000;
  setTimeout(() => {
    activeToasts.delete(key);
  }, duration + 500);
  
  // Call appropriate sonner toast method
  return sonnerToast[type](message, {
    ...options,
    onDismiss: () => {
      activeToasts.delete(key);
      options.onDismiss?.();
    },
    onAutoClose: () => {
      activeToasts.delete(key);
      options.onAutoClose?.();
    },
  });
};

// Export toast methods
export const toast = {
  success: (message, options) => showToast(message, 'success', options),
  error: (message, options) => showToast(message, 'error', options),
  info: (message, options) => showToast(message, 'info', options),
  warning: (message, options) => showToast(message, 'warning', options),
  loading: (message, options) => sonnerToast.loading(message, options),
  promise: (promise, options) => sonnerToast.promise(promise, options),
  dismiss: (toastId) => sonnerToast.dismiss(toastId),
};

export default toast;
